<header
    class="empty"
    style="background-image: url(./frontend/img/header-bg.jpg)"
></header>
<div class="container">
    <h1>Willkommen im Gastivo-Admin!</h1>
</div>
